import { useState } from 'react'
import { getUsuarioStorage } from '../helpers/getUsuarioStorage'

export const useGetPantallas = () => {
  
  let [usuario] = useState( getUsuarioStorage() )
  const pantallas = usuario.pantallas !== null ? usuario.pantallas.split(",") : [];
  
  return (
    pantallas
  )
}
